import * as React from "react";
import { SVGProps, memo } from "react";

const SvgArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.613 10.014 5.9 3.303a.75.75 0 0 1 1.06-1.06l7.067 7.065a1 1 0 0 1 0 1.415L6.99 17.759a.75.75 0 1 1-1.06-1.06l6.683-6.685Z"
      fill="#637182"
    />
  </svg>
);

const Memo = memo(SvgArrowRight);

export default Memo;
